import { z } from "zod";
import { WorkspaceRoleSchema } from "./auth";

/** A Workspace — the tenant root above Shop. */
export const WorkspaceSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  created_at: z.string().datetime().optional(),
});

/** A User's Membership row in a Workspace. */
export const WorkspaceMemberSchema = z.object({
  user_id: z.string().uuid(),
  email: z.string().email().optional(),
  name: z.string().nullable().optional(),
  avatar_url: z.string().nullable().optional(),
  role: WorkspaceRoleSchema,
  status: z.enum(["active", "removed"]),
  joined_at: z.string().datetime().nullable(),
});

/** Response of `GET /me/workspaces` — the Workspaces the User is a Member of + the active one. */
export const WorkspaceListResponseSchema = z.object({
  workspaces: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      role: WorkspaceRoleSchema,
      // present when this Workspace is the User's active one
      is_active: z.boolean().optional(),
    }),
  ),
  active_workspace_id: z.string().uuid().nullable(),
});

export const UpdateWorkspaceSchema = z.object({
  name: z.string().trim().min(1).max(100),
});

export const WorkspaceProfileSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdAt: z.string().datetime(),
  memberCount: z.number().int().nonnegative(),
  shopCount: z.number().int().nonnegative(),
});
export type WorkspaceProfile = z.infer<typeof WorkspaceProfileSchema>;

/** Response of the active-Workspace mutation. */
export const ActiveWorkspaceResponseSchema = z.object({
  activeWorkspaceId: z.string().uuid(),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
export type WorkspaceMember = z.infer<typeof WorkspaceMemberSchema>;
export type WorkspaceListResponse = z.infer<typeof WorkspaceListResponseSchema>;
export type UpdateWorkspace = z.infer<typeof UpdateWorkspaceSchema>;
